import { render, staticRenderFns } from "./FrameTile.vue?vue&type=template&id=87c51094&scoped=true&"
import script from "./FrameTile.vue?vue&type=script&lang=ts&"
export * from "./FrameTile.vue?vue&type=script&lang=ts&"
import style0 from "./FrameTile.vue?vue&type=style&index=0&id=87c51094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c51094",
  null
  
)

export default component.exports